<template>
  <div class='h-dialogContainer'>
    <div v-for='(set, index) in setting' :key='index' class='row h-row-inputBox'>
      <div class='col-sm-2 h-col-inputBox'>
        <div class='h-inputLit'>{{set.inputName}}:</div>
        <ejs-switch v-model='set.isAct' :checked='set.isAct'></ejs-switch>
      </div>
      <div class='col-sm-3 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.alarmType')}}:</div>
        <div class='row'>
            <ejs-dropdownlist v-model="set.type" :fields='listFields' :dataSource='typeList' :placeholder='listPlaceholder'></ejs-dropdownlist>
        </div>
      </div>
      <div class='col-sm-3 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.alarmStatus')}}:</div>
        <div class='row'>
            <ejs-dropdownlist v-model="set.status" :fields='listFields' :dataSource='statusList' :placeholder='listPlaceholder'></ejs-dropdownlist>
        </div>
      </div>
      <div class='col-sm-4 h-col-inputBox'>
        <div class='h-inputLit'>{{$t('Alarm.confirmCycle')}}:</div>
        <div class='row'>
          <div class='col-sm-6 nopadding'>
            <ejs-textbox :change="fuzzySearch" v-model="set.interval"></ejs-textbox>
          </div>
          <div class='col-sm-6 nopadding'>
            <ejs-dropdownlist v-model="set.unit" :fields='listFields' :dataSource='timeList' :placeholder='listPlaceholder' :change="fuzzySearch"></ejs-dropdownlist>
          </div>
        </div>
      </div>
    </div>
    <div class='h-clear-rowMg'></div>
  </div>
</template>
<script>
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'autoConfirmSetting',
  data() {
    return {
      listPlaceholder: this.$t('Alarm.pleaseChoose'),
      listFields: {
        text: 'name',
        value: 'code'
      },
      timeList: [
        { name: this.$t('Alarm.minute'), code: 'Minute' },
        { name: this.$t('Alarm.hour'), code: 'Hour' },
        { name: this.$t('Alarm.day'), code: 'Day' }
      ],
      typeList: [
        { name: this.$t('Common.all'), code: -1 },
        { name: this.$t('Alarm.alarmType_0'), code: 0 },
        { name: this.$t('Alarm.alarmType_1'), code: 1 },
        { name: this.$t('Alarm.alarmType_2'), code: 2 },
        { name: this.$t('Alarm.alarmType_3'), code: 3 },
        { name: this.$t('Alarm.alarmType_4'), code: 4 },
      ],
      statusList: [
        { name: this.$t('Common.all'), code: -1 },
        { name: this.$t('Alarm.alarmClearStatus_0'), code: 0 },
        { name: this.$t('Alarm.alarmClearStatus_1'), code: 1 }
      ],
      setting: [{
        name: 'critical',
        level: 0,
        inputName: `${this.$t('Alarm.alarmLevel_0')}${this.$t('Alarm.alarm')}`,
        interval: '',
        unit: '',
        type: -1,
        status: -1,
        isAct: false
      }, {
        name: 'major',
        level: 1,
        inputName: `${this.$t('Alarm.alarmLevel_1')}${this.$t('Alarm.alarm')}`,
        interval: '',
        unit: '',
        type: -1,
        status: -1,
        isAct: false
      }, {
        name: 'minor',
        level: 2,
        inputName: `${this.$t('Alarm.alarmLevel_2')}${this.$t('Alarm.alarm')}`,
        interval: '',
        unit: '',
        type: -1,
        status: -1,
        isAct: false
      }, {
        name: 'warning',
        level: 3,
        inputName: `${this.$t('Alarm.alarmLevel_3')}${this.$t('Alarm.alarm')}`,
        interval: '',
        unit: '',
        type: -1,
        status: -1,
        isAct: false
      }],
      originalSetting:[{},{},{},{}]
    };
  },
  methods: {
    getAutoConfirmInfo() {
      this.$axios.get('/lte/ems/fm/alarmcurrent/autoConfirmInfo', {}).then((response) => {
        if (response && response.status === 200) {
          const data = response.data.resultVal.alarmAutoConfirm.confirm;
          for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < this.setting.length; j++) {
              if (data[i].level === this.setting[j].level) {
                this.setting[j].interval = data[i].interval == 36500 ? "" : data[i].interval;
                this.setting[j].unit = data[i].unit;
                this.setting[j].isAct = data[i].isAct;
                this.setting[j].type = data[i].type;
                this.setting[j].status = data[i].status;
                this.originalSetting[j].interval = this.setting[j].interval;
              }
            }
          }
        }
      });
    },
    getConditionData() {
      const isActMap = {};
      const cycleNumMap = {};
      const cycleMap = {};
      const conditions = {};
      const typeMap = {};
      const statusMap = {};

      for (let i = 0; i < this.setting.length; i++) {
        this.setting[i].interval = this.setting[i].interval + '';
        this.setting[i].unit = this.setting[i].unit + '';
        if (this.setting[i].interval.trim() === "0" || this.setting[i].interval.trim() === "" || this.setting[i].unit.trim() === "") {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.confirmSettingParameter')});
          return false;
        }
        isActMap[this.setting[i].name] = this.setting[i].isAct ? '1' : '0';
        cycleNumMap[`${this.setting[i].name}Num`] = this.setting[i].interval.trim();
        cycleMap[`${this.setting[i].name}Cycle`] = this.setting[i].unit.trim();
        typeMap[`${this.setting[i].name}`] = this.setting[i].type;
        statusMap[`${this.setting[i].name}`] = this.setting[i].status;
      }
      conditions.isActMap = isActMap;
      conditions.cycleNumMap = cycleNumMap;
      conditions.cycleMap = cycleMap;
      conditions.typeMap = typeMap;
      conditions.statusMap = statusMap;
      return JSON.stringify(conditions);
    },
    fuzzySearch() {
      for (let i = 0; i < this.setting.length; i++) {
         if(!(/(^[1-9]\d*$)/.test(this.setting[i].interval))){
             this.setting[i].interval = this.originalSetting[i].interval
         }else{
             if(this.setting[i].unit === 'Minute' && this.setting[i].interval > 180){
                this.setting[i].interval = 180;
             }else if(this.setting[i].unit === 'Hour' && this.setting[i].interval > 24){
                this.setting[i].interval = 24;
             }else if(this.setting[i].unit === 'Day' && this.setting[i].interval > 365){
                this.setting[i].interval = 365;
             }
         }
      }
    }
  }
};
</script>
